import { createAction, props } from '@ngrx/store';

//#region 메뉴관련
export const openMenu = createAction('[Layout] open menu');
export const closeMenu = createAction('[Layout] close menu');
export const toggleMenu = createAction('[Layout] toggle menu');
//#endregion

export const openSignIn = createAction('[Layout] open sigin in');
